import FooterPattern from './FooterPattern';

export default FooterPattern;
